import Vue from 'vue';
import App from './App.vue';
//import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router';
import router from './router'
import vuetify from '@/plugins/vuetify'
import '@mdi/font/css/materialdesignicons.min.css'


import axios from 'axios'

// 设置全局请求头（对所有请求生效）
axios.defaults.headers.common['Authorization'] = localStorage.getItem('authToken'); // 认证 token
axios.defaults.headers.common['Content-Type'] = 'application/json' // 默认内容类型
axios.defaults.headers.get['Accept-Language'] = 'zh-CN'
//axios.defaults.withCredentials = true;

Vue.use(VueRouter)
//Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.serverUrl = "/kt-supplier"
Vue.prototype.serverYdnUrl = "/ydn"
Vue.prototype.venderId = localStorage.getItem('venderId')
new Vue({
	router,
	vuetify,
	render: h => h(App)
}).$mount('#app')